<template>
  <div id="page-scroll-box">
    <div class="scrollBox">
      <div class="wrapper" ref="wrapper">
        <div class="content">
          <slot></slot>
          <div class="showLoading" v-if="showLoading">{{$t('Common.loadCountine')}}</div>
        </div>
        <!-- <Nav /> -->
      </div>
    </div>
  </div>
</template>
<script>
import BetterScroll from "better-scroll";
export default {
  name: "scroll-box-view",
  props: ["list", "showLoading"],
  mounted() {
    this.$nextTick(() => {
      this.scroll = new BetterScroll(this.$refs.wrapper, {
        scrollY: {
          type: Boolean,
          default: true
        },
        bounce: {
          top: false,
          bottom: true,
          left: false,
          right: false
        },
        mouseWheel: {
          speed: 20,
          invert: false,
          easeTime: 100
        },
        click: true,
        probeType: {
          type: Number,
          default: 3
        },
        pullDownRefresh: false,
        pullUpLoad: {
          threshold: 0
        }
      });
      this.scroll.on("pullingUp", () => {
        this.$emit("getData");
      });
    });
  },
  watch: {
    list(o, n) {
      this.$nextTick(() => {
        this.scroll.finishPullUp();
        this.scroll.refresh();
      });
    }
  }
};
</script>
<style lang="less" scoped>
#page-scroll-box {
  height: 100%;
  & > .scrollBox {
    height: 100%;
    .wrapper {
      height: 100%;
      overflow: hidden;
    }
    .showLoading {
      display: flex;
      align-items: center;
      justify-content: center;
      line-height: 60px;
    }
    .content {
      min-height: 100%;
    }
  }
}
</style>